import { render, staticRenderFns } from "./UserQualifications.vue?vue&type=template&id=93db7b6c&scoped=true&"
import script from "./UserQualifications.vue?vue&type=script&lang=js&"
export * from "./UserQualifications.vue?vue&type=script&lang=js&"
import style0 from "./UserQualifications.vue?vue&type=style&index=0&id=93db7b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93db7b6c",
  null
  
)

/* custom blocks */
import block0 from "./UserQualifications.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./UserQualifications.vue?vue&type=custom&index=1&blockType=i18n&lang=yaml&locale=dk"
if (typeof block1 === 'function') block1(component)

export default component.exports